import { Avatar, Dropdown, Layout, Menu, Space, Tag } from '@arco-design/web-react';
import {
  IconDashboard,
  IconIdcard,
  IconList,
  IconUser,
  IconUserGroup,
  IconPoweroff,
} from '@arco-design/web-react/icon';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';
import { formatMoney } from '@/utils/money';

const { Sider, Header, Content } = Layout;

const menuItems: Array<{ key: string; label: string; icon: JSX.Element }> = [
  { key: '/dashboard', label: '全局控制面板', icon: <IconDashboard /> },
  { key: '/cards', label: '我的卡包资产', icon: <IconIdcard /> },
  { key: '/billing-templates', label: '持卡人地址模板', icon: <IconUserGroup /> },
  { key: '/transactions', label: '财务对账明细', icon: <IconList /> },
  { key: '/profile', label: '个人设置中心', icon: <IconUser /> },
];

export default function AppLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const { profile, logout } = useAuthStore();

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider
        width={220}
        style={{
          background: '#0f1f48',
        }}
      >
        <div
          style={{
            height: 56,
            display: 'flex',
            alignItems: 'center',
            padding: '0 20px',
            color: '#fff',
            fontSize: 18,
            fontWeight: 600,
            letterSpacing: 1,
            borderBottom: '1px solid rgba(255,255,255,0.08)',
          }}
        >
          UP·CARD
        </div>
        <Menu
          theme="dark"
          selectedKeys={[location.pathname]}
          onClickMenuItem={(key) => navigate(key)}
          style={{ background: 'transparent' }}
        >
          {menuItems.map((item) => (
            <Menu.Item key={item.key}>
              <Space>
                {item.icon}
                {item.label}
              </Space>
            </Menu.Item>
          ))}
        </Menu>
      </Sider>

      <Layout>
        <Header
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            background: '#fff',
            height: 56,
            padding: '0 24px',
            borderBottom: '1px solid var(--up-border-light)',
          }}
        >
          <Space size="large">
            <Tag color="arcoblue" bordered>
              环境：{import.meta.env.MODE}
            </Tag>
            {profile ? (
              <span style={{ color: 'var(--up-color-text-secondary)' }}>
                母账户余额 ·{' '}
                <strong style={{ color: 'var(--up-color-text-primary)' }}>
                  {formatMoney(profile.walletBalanceCents)}
                </strong>
              </span>
            ) : null}
          </Space>
          <Dropdown
            droplist={
              <Menu
                onClickMenuItem={async (key) => {
                  if (key === 'profile') navigate('/profile');
                  if (key === 'logout') {
                    await logout();
                    navigate('/login');
                  }
                }}
              >
                <Menu.Item key="profile">
                  <IconUser /> 个人设置
                </Menu.Item>
                <Menu.Item key="logout">
                  <IconPoweroff /> 退出登录
                </Menu.Item>
              </Menu>
            }
          >
            <Space style={{ cursor: 'pointer' }}>
              <Avatar size={32} style={{ backgroundColor: 'var(--up-color-brand)' }}>
                {profile?.username?.slice(0, 1)?.toUpperCase() ?? 'U'}
              </Avatar>
              <span>{profile?.username ?? '未登录'}</span>
            </Space>
          </Dropdown>
        </Header>
        <Content style={{ background: 'var(--up-bg-page)' }}>
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
}
